import { Box, Button } from '@mui/material';

import { HeaderWrapper, HeaderLogo, HeaderLinks } from './styles';
import { logoAlluraDirect } from 'config/imageUrls';
import { useListPageModalNavigation } from '../modal/hooks/useListPageModalNavigation';
import { ListPageAnchorEnum } from '../types';
import { useToggle } from '@alluradirect/react';
import { PageHeaderHelpDialog } from 'components/layout/Page/components/PageHeaderHelpDialog';

export const TopNavLinks = ({ openModal }: { openModal: () => void }) => {
  const { pushUnassistedUrl } = useListPageModalNavigation();
  const handleCLick = () => {
    pushUnassistedUrl();
    openModal();
  };
  const helpToggle = useToggle();

  return (
    <>
      <HeaderWrapper container>
        <HeaderLogo item xs={12} sm={4}>
          <a href={`https://${process.env.NEXT_PUBLIC_BASE_URL}`}>
            <img src={logoAlluraDirect} />
          </a>
        </HeaderLogo>
        <HeaderLinks item xs={12} sm={8}>
          <Box>
            <Button variant="text" color="secondary" href={`#${ListPageAnchorEnum.overview}`}>
              Overview
            </Button>
            <Button variant="text" color="secondary" href={`#${ListPageAnchorEnum.features}`}>
              Features
            </Button>
            <Button variant="text" color="secondary" href={`#${ListPageAnchorEnum.pricing}`}>
              Pricing
            </Button>
            <Button variant="text" color="secondary" onClick={helpToggle.open}>
              Contact
            </Button>
            <Button variant="contained" color="secondary" onClick={handleCLick}>
              Get Started
            </Button>
          </Box>
        </HeaderLinks>
      </HeaderWrapper>
      {helpToggle.isOpen ? <PageHeaderHelpDialog isOpen={helpToggle.isOpen} close={helpToggle.close} /> : null}
    </>
  );
};
